<!-- 调用 -->
<template></template>
 
<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="less" scoped></style>
